// extracted by mini-css-extract-plugin
export var sliderRange = "_o4-2";
export var sliderRoot = "_o4-0";
export var sliderThumb = "_o4-3";
export var sliderTrack = "_o4-1";